import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-datepicker',
	imports: [SharedModule, DatepickerComponent, UiCodeBlockComponent],
	templateUrl: './ui-datepicker.component.html',
	styleUrl: './ui-datepicker.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiDatepickerComponent {
	@Input() datepickerControl!: FormControl;
	@Input() disabledDatepickerControl!: FormControl;
	@Input() errorDatepickerControl!: FormControl;
	@Input() rangeDatepickerControl!: FormControl;
	@Input() inlineDatepickerControl!: FormControl;
	@Input() weekViewControl!: FormControl;
	@Input() timeDatepickerControl!: FormControl;

	// Sample event dates for examples
	eventDates: Date[] = [new Date(2025, 0, 15), new Date(2025, 0, 20), new Date(2025, 0, 25)];

	requestDates: Date[] = [new Date(2025, 0, 10), new Date(2025, 0, 18)];

	generateCode(attrs: {
		formControl?: string;
		placeholder?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
		rangeMode?: boolean;
		inline?: boolean;
		view?: string;
		showWeek?: boolean;
		numberOfDays?: number;
		eventDates?: string;
		requestDates?: string;
		showTimeInputs?: boolean;
		useSpecialContainer?: boolean;
	}): string {
		let code = '<app-datepicker';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;
		if (attrs.rangeMode) code += `\n    [rangeMode]="true"`;
		if (attrs.inline) code += `\n    [inline]="true"`;
		if (attrs.view) code += `\n    view="${attrs.view}"`;
		if (attrs.showWeek) code += `\n    [showWeek]="true"`;
		if (attrs.numberOfDays) code += `\n    [numberOfDays]="${attrs.numberOfDays}"`;
		if (attrs.eventDates) code += `\n    [eventDates]="${attrs.eventDates}"`;
		if (attrs.requestDates) code += `\n    [requestDates]="${attrs.requestDates}"`;
		if (attrs.showTimeInputs) code += `\n    [showTimeInputs]="true"`;
		if (attrs.useSpecialContainer) code += `\n    [useSpecialContainer]="true"`;

		code += '\n/>';
		return code;
	}
}
